import { Injectable } from "@angular/core";
import { ServiceBase, apiRequest } from "services";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { YTBCouponValidation } from "@models/ytbCouponValidation";
@Injectable({
  providedIn: "root"
})
export class ActivitesService extends ServiceBase {
  ActSearchSuccess: Subject<any>;
  ActSearchRequest: Subject<any>;
  ActSearchDetails: Subject<any>;
  ActCheckAvailability: Subject<any>;
  Travellerpricedetails: Subject<any>;
  BookingSuccess: Subject<any>;
  ActivityCategories: Subject<any>;
  ActivitysAtraction: Subject<any>;
  ActivityReviews: Subject<any>;
  pricecalender: Subject<any>;
  PaypalDetails: Subject<any>;
  nearbySuccess: Subject<any>;
  hotelDetails: Subject<any>;
  monthlyTourGrades: Subject<any>;

  QUERYPARAMSINSERTIONOFACTIVITIES$: Subject<any>;
  ActivityBarCodeUpdate$: Subject<any>;
  ActivityLpSuccess: Subject<any>;
  ACTIVITYCOUPONVALIDATIONSUCCESS$: Subject<any>;

  constructor(http: HttpClient) {
    super(http);
    this.ACTIVITYCOUPONVALIDATIONSUCCESS$ = new Subject<any>();

    this.ActSearchSuccess = new Subject<any>();
    this.ActSearchRequest = new Subject<any>();
    this.ActSearchDetails = new Subject<any>();
    this.ActCheckAvailability = new Subject<any>();
    this.Travellerpricedetails = new Subject<any>();
    this.BookingSuccess = new Subject<any>();
    this.ActivityCategories = new Subject<any>();
    this.ActivitysAtraction = new Subject<any>();
    this.ActivityReviews = new Subject<any>();
    this.pricecalender = new Subject<any>();
    this.PaypalDetails = new Subject<any>();
    this.nearbySuccess = new Subject<any>();
    this.hotelDetails = new Subject<any>();
    this.monthlyTourGrades = new Subject<any>();
    this.QUERYPARAMSINSERTIONOFACTIVITIES$ = new Subject<any>();
    this.ActivityBarCodeUpdate$ = new Subject<any>();
    this.ActivityLpSuccess = new Subject<any>();
  }


  // Activities Coupon Valdiation
  activitiesCouponValidation(couponObj: YTBCouponValidation) {
    this.post<any>({
      url: "Common/YTBCoupon/v1/YTBCouponValidation",
      onNotify: this.ACTIVITYCOUPONVALIDATIONSUCCESS$,
      data: couponObj, operationKey: 'Coupon_issue'
    } as apiRequest<any>);
  }



  //activites Serach dropdown
  activitesSearchDropDown(search) {
    this.post<any>({
      url: "Activity/activitesSearch",
      onNotify: this.ActSearchSuccess,
      data: search
    } as apiRequest<any>);
  }

  //activites Serach request
  activitesSearchRequest(searchreq) {
    this.post<any>({
      url: "Activity/activity/v1/ProductSearch",
      onNotify: this.ActSearchRequest,
      data: searchreq, operationKey: 'Search_issue'
    } as apiRequest<any>);
  }

  //activites Serach details
  activitesSearchDetails(searchdetails) {
    this.post<any>({
      url: "Activity/activity/v1/GetProductDetailInfo",
      onNotify: this.ActSearchDetails,
      data: searchdetails, operationKey: 'Details_issue'
    } as apiRequest<any>);
  }
  //activites Serach details check availablility

  activitesCheckavail(checkavail) {
    this.post<any>({
      url: "/Activity/activity/v1/GetAvailabeDate",
      onNotify: this.ActCheckAvailability,
      data: checkavail
    } as apiRequest<any>);
  }

  activitesTravellerpricedetails(travellerprice) {
    this.post<any>({
      url: "Activity/activity/v1/AvailableTourGrades",
      onNotify: this.Travellerpricedetails,
      data: travellerprice
    } as apiRequest<any>);
  }

  activitesBookingrequest(bookingobj) {
    this.post<any>({
      url: "/Activity/activity/v1/MakeBooking",
      onNotify: this.BookingSuccess,
      data: bookingobj, operationKey: 'Booking_issue'
    } as apiRequest<any>);
  }
  activitycategories(category) {
    this.post<any>({
      url: "Activity/activity/v1/GetCategories",
      onNotify: this.ActivityCategories,
      data: category
    } as apiRequest<any>);
  }

  activityAtraction(atraction) {
    this.post<any>({
      url: "Activity/activity/v1/GetAttraction",
      onNotify: this.ActivitysAtraction,
      data: atraction
    } as apiRequest<any>);
  }

  getReviews(reviews) {
    this.post<any>({
      url: "Activity/activity/v1/GetProductReviews",
      onNotify: this.ActivityReviews,
      data: reviews
    } as apiRequest<any>);
  }

  farecalender(atraction) {
    this.post<any>({
      url: "Activity/activity/v1/FareCalendar",
      onNotify: this.pricecalender,
      data: atraction
    } as apiRequest<any>);
  }

  makePaypalPayment(paymentDetails) {
    this.post<any>({
      url: "Payments/PayPal/MakePayment",
      onNotify: this.PaypalDetails,
      data: paymentDetails
    } as apiRequest<any>);
  }

  nearbysearch(search) {
    this.post<any>({
      url: "Activity/activitesSearch",
      onNotify: this.nearbySuccess,
      data: search
    } as apiRequest<any>);
  }

  GetHotels(productObj) {
    this.post<any>({
      url: "Activity/activity/v1/GetHotels",
      onNotify: this.hotelDetails,
      data: productObj
    } as apiRequest<any>);
  }

  GetAvailableTourGradesByMonth(gradeObj) {
    this.post<any>({
      url: "Activity/activity/v1/MonthlyAvailableTourGrades",
      onNotify: this.monthlyTourGrades,
      data: gradeObj
    } as apiRequest<any>);
  }

  /**
   * 
   * @param requestObj 
   * This function is used to insert is there any multiple set calls in same component.
   * 
   */
  additionalQueryParamsInsertion(requestObj) {
    return this.post({ url: "Common/Request/v1/InsertQueryParams", data: requestObj, onNotify: this.QUERYPARAMSINSERTIONOFACTIVITIES$ });

  }

  /**
   * 
   * @param requestObj 
   * This function is used to insert is there any multiple set calls in same component.
   * 
   */
  activityBarCodeUpdate(requestObj) {
    return this.post({ url: "Common/Booking/v1/ActivityBarCodeUpdate", data: requestObj, onNotify: this.ActivityBarCodeUpdate$ });

  }

  getDestinations(destinationId) {
    return this.get<boolean>({
      url: 'Common/ActivityLandingPage/' + destinationId,
      onNotify: this.ActivityLpSuccess
    } as apiRequest<any>);
  }


}
